import React from 'react'
import NavLink from '../common/NavLink'
import { connect } from 'react-redux'

class RepMenuItems extends React.Component {
  render() {
    const { supervisorId } = this.props

    return (
      <div className="vertical-menu">
        <NavLink to="/dashboard">
          <i className="fa fa-calendar" aria-hidden="true" />
          {/* <span>داشبورد</span> */}
          <span>رویدادها</span>
        </NavLink>

        {/* <NavLink to="/dashboard/supervisor/events">
          <i className="fa fa-calendar" aria-hidden="true" />
          <span>رویدادها</span>
        </NavLink> */}

        {/* <NavLink to={`/dashboard/supervisor/${supervisorId}/students`}>
          <i className="fa fa-user-o" aria-hidden="true" />
          <span>لیست دانش آموزان</span>
        </NavLink> */}

        {/*
          <NavLink to="/dashboard/profile">
          <i className="fa fa-user" aria-hidden="true" />
          <span>پروفایل</span>
          </NavLink>
        */}

        {/*
          <NavLink to="/dashboard/account">
            <i className="fa fa-user" aria-hidden="true" />
            <span>حساب کاربری</span>
          </NavLink>
        */}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  ...state.routing.locationBeforeTransitions,
  supervisorId: state.auth.userId
})

export default connect(mapStateToProps)(RepMenuItems)



// WEBPACK FOOTER //
// ./src/components/supervisor/SupervisorMenuItems.js